/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ReplacementTicketToLinkList } from '../../models/replacement-ticket-to-link-list';

export interface WarehouseControllerFindReplacementTicketsToLink$Params {

/**
 * Commessa del rientro: restringe ai ticket della commessa (o della sua commessa madre/figlia)
 */
  related_agreement_id?: number;

/**
 * Numero ticket o parte del nome del cliente
 */
  search?: string;
}

export function warehouseControllerFindReplacementTicketsToLink(http: HttpClient, rootUrl: string, params?: WarehouseControllerFindReplacementTicketsToLink$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ReplacementTicketToLinkList;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerFindReplacementTicketsToLink.PATH, 'get');
  if (params) {
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ReplacementTicketToLinkList;
      }>;
    })
  );
}

warehouseControllerFindReplacementTicketsToLink.PATH = '/warehouse/return-replacement-tickets';
